import React from "react";
import {TextToolTip} from "../table";

export const DialysisBadge = ({item}) => {
    if (!item?.dialysis) return null;
    return (
        <TextToolTip
            showTooltip
            arrow
            content="Dialysis"
            text="D"
            wrapperStyles={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: '16px',
                minWidth: '16px',
                height: '16px',
                borderRadius: '4px',
                backgroundColor: '#17B986',
            }}
            textStyles={{width:'fit-content', color: '#FFF', fontSize: 10, fontWeight: 700}}
        />
    );
};
